module.exports = __webpack_public_path__ + "static/img/third2_2_6.f25fdf16.jpg";